import { gql, useLazyQuery } from "@apollo/client"
import { DownloadLink, QueryDocumentDownloadLinkArgs } from "@oysterhr/schema"

const QUERY = gql`
  query StaffInvoicingPaymentStatusSectionDocumentDownloadLink($documentId: ID!) {
    documentDownloadLink(documentId: $documentId) {
      url
    }
  }
`

export const useLazyDocumentDownloadLink = () =>
  useLazyQuery<
    { documentDownloadLink: DownloadLink },
    Pick<QueryDocumentDownloadLinkArgs, "documentId">
  >(QUERY, { fetchPolicy: "no-cache" })
